'use client';
import { useState } from 'react';

import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/slw/shared/ui/accordion';
import { Card, CardContent } from '@/slw/shared/ui/card';

export function ListingPackages() {
  const [open, setOpen] = useState(true);

  const triggerClass = 'md:pt-6 md:pb-4 py-4 text-sm md:text-base font-semibold leading-[100%] flex items-center';

  return (
    <Card className='rounded-2xl bg-[#F7F7F7] shadow-sm mb-8 border-0 p-6 md:p-8'>
      <div className='flex items-center justify-between'>
        <h3 className='text-xl md:text-[2rem] leading-[100%] font-bold text-foreground'>Listing Packages & Upgrades</h3>
        <button
          type='button'
          className='text-sm font-normal leading-[150%] text-muted-foreground hover:text-primary transition'
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'Hide' : 'Show'}
        </button>
      </div>
      {open && (
        <CardContent className='pt-0 px-0 pb-0'>
          <Accordion type='multiple' className='divide-y divide-[#E5E5E5]'>
            <AccordionItem value='listing-packages'>
              <AccordionTrigger className={triggerClass}>
                What’s the difference between listing packages?
              </AccordionTrigger>
              <AccordionContent className='pl-0 text-sm leading-[150%]'>
                <div>
                  <p>We offer two tiers:</p>
                  <p>Standard Listing ($99): 30 photos, basic promotion, unlimited listing time</p>
                  <p>
                    Premium Listing ($299): Featured listing status, newsletter mention, social media promotion, video +
                    100 pictures, and more
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value='upgrade-listing'>
              <AccordionTrigger className={triggerClass}>Can I upgrade my listing later?</AccordionTrigger>
              <AccordionContent className='pl-0 text-sm leading-[150%]'>
                Yes. You can upgrade from free or standard to premium at any time via your seller dashboard.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value='get-help-writing-listing'>
              <AccordionTrigger className={triggerClass}>
                Can I get help writing or formatting my listing?
              </AccordionTrigger>
              <AccordionContent className='pl-0 text-sm leading-[150%]'>
                Yes. Our Premium Concierge add-on includes professional copywriting and listing design assistance.
                Contact support@ClovisClassics.com to learn more.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </CardContent>
      )}
    </Card>
  );
}
